import { Action } from '@ngrx/store';
import { IAuthCommon, IAuthTable } from './auth.interfaces';
import { RequestAccess } from '../../shared/models/request-access';
import { ResetPasswordUser } from 'src/app/shared/models/reset-password-user';

export enum AuthActionTypes {
  LOGIN = '[Auth] Login',
  REMOTE_LOGIN = '[Auth] Remote Login',
  LOGIN_SUCCESS = '[Auth] Login Success',
  LOGIN_SUCCESS_REDIRECT = '[Auth] Login Success Redirect',
  LOGIN_FAILURE = '[Auth] Login Failure',
  CHECK_LOGIN = '[Auth] Check Login',
  CHECK_LOGIN_FAILURE = '[Auth] Check Login Failure',
  RESET_PASSWORD = '[Auth] Reset Password',
  RESET_PASSWORD_COMPLETE = '[Auth] Reset Password Complete',
  SIGN_UP = '[Auth] Sign Up',
  SIGN_UP_SUCCESS = '[Auth] Sign Up Success',
  SIGN_UP_FAILURE = '[Auth] Sign Up Failure',
  LOGOUT = '[Auth] Logout',
  REFRESH_TOKEN = '[Auth] Refresh Token',
  REFRESH_TOKEN_SUCCESS = '[Auth] Refresh Token Success',
  REFRESH_TOKEN_FAILURE = '[Auth] Refresh Token Failure',
  DISPLAY_ERROR = '[Auth] Display Error',
  FORGOT_PASSWORD = '[Auth] Forgot Password',
  FORGOT_PASSWORD_COMPLETE = '[Auth] Forgot Password Complete',
  FORGOT_PASSWORD_ERROR = '[Auth] Forgot Password Error',
}

export class Login implements Action {
  readonly type = AuthActionTypes.LOGIN;
  constructor(
    public payload: { userName: string; password: string },
    public redirectTo?: string
  ) {}
}

export class RemoteLogin implements Action {
  readonly type = AuthActionTypes.REMOTE_LOGIN;
  constructor(public payload: { encryptedString: string }) {}
}

export class LoginSuccess implements Action {
  readonly type = AuthActionTypes.LOGIN_SUCCESS;
  constructor(public payload: IAuthTable, public redirectTo?: string) {}
}

export class LoginFailure implements Action {
  readonly type = AuthActionTypes.LOGIN_FAILURE;
  constructor(public payload: string) {}
}

export class CheckLogin implements Action {
  readonly type = AuthActionTypes.CHECK_LOGIN;
}

export class CheckLoginFailure implements Action {
  readonly type = AuthActionTypes.CHECK_LOGIN_FAILURE;
}

export class SignUp implements Action {
  readonly type = AuthActionTypes.SIGN_UP;
  constructor(public payload: RequestAccess) {}
}

export class SignUpSuccess implements Action {
  readonly type = AuthActionTypes.SIGN_UP_SUCCESS;
  constructor(public payload: string) {}
}

export class RefreshToken implements Action {
  readonly type = AuthActionTypes.REFRESH_TOKEN;
}

export class RefreshTokenSuccess implements Action {
  readonly type = AuthActionTypes.REFRESH_TOKEN_SUCCESS;
  constructor(public payload: IAuthTable) {}
}

export class RefreshTokenFailure implements Action {
  readonly type = AuthActionTypes.REFRESH_TOKEN_FAILURE;
  constructor(public payload: string) {}
}

export class SignUpFailure implements Action {
  readonly type = AuthActionTypes.SIGN_UP_FAILURE;
  constructor(public payload: string) {}
}

export class ResetPassword implements Action {
  readonly type = AuthActionTypes.RESET_PASSWORD;
  constructor(public payload: ResetPasswordUser) {}
}

export class ResetPasswordComplete implements Action {
  readonly type = AuthActionTypes.RESET_PASSWORD_COMPLETE;
}

export class Logout implements Action {
  readonly type = AuthActionTypes.LOGOUT;
}

export class LoginSuccessRedirect implements Action {
  readonly type = AuthActionTypes.LOGIN_SUCCESS_REDIRECT;
  constructor(public redirectTo?: string) {}
}

export class DisplayError implements Action {
  readonly type = AuthActionTypes.DISPLAY_ERROR;
  constructor(public payload: string) {}
}

export class ForgotPassword implements Action {
  readonly type = AuthActionTypes.FORGOT_PASSWORD;
  constructor(public payload: string) {}
}

export class ForgotPasswordComplete implements Action {
  readonly type = AuthActionTypes.FORGOT_PASSWORD_COMPLETE;
}

export class ForgotPasswordError implements Action {
  readonly type = AuthActionTypes.FORGOT_PASSWORD_ERROR;
  constructor(public payload: string) {}
}

export type AuthActions =
  | Login
  | LoginSuccess
  | LoginFailure
  | Logout
  | CheckLogin
  | CheckLoginFailure
  | ResetPassword
  | ResetPasswordComplete
  | LoginSuccessRedirect
  | SignUp
  | SignUpSuccess
  | SignUpFailure
  | RefreshTokenSuccess
  | RefreshToken
  | RefreshTokenFailure
  | ForgotPassword
  | ForgotPasswordComplete
  | ForgotPasswordError
  | DisplayError
  | RemoteLogin;
